import React from "react";
import { Routes, Route } from "react-router-dom";
import { ROUTES } from "./utils";

function App() {
  return (
    <Routes>
      {
        ROUTES.map((route, index) => {
          return <Route key={`route-${index}`} path={route.path} element={route.component} />
        })
      }
    </Routes>
  );
}

export default App;
